import { publicApi, protectedApi } from '../config/api.config';
import { logError } from '../utils/errorLogger';

class ParametresEntrepriseApi {
  async getParametres() {
    try {
      const response = await publicApi.get('/parametres-entreprise');
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }

  async updateParametres(formData) {
    try {
      const response = await protectedApi.put('/parametres-entreprise', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (error) {
      logError(error);
      throw error;
    }
  }
}

export default new ParametresEntrepriseApi();
